import { computed } from 'vue';
import { OfflineStatus } from '@libs/api-reference';
import { useQueryV2 } from '@libs/use';

import * as API from '../requests';
import { ORDERS_QUERY_KEYS } from '../constants';

export default function useGetOfflineOrderStatusQuery() {
  const {
    result,
    isPending: isLoadingOfflineStatus,
    isError: isErrorOfflineStatus,
    isSuccess: isSuccessOfflineStatus,
  } = useQueryV2<OfflineStatus>(API.getOfflineStatus, {
    key: ORDERS_QUERY_KEYS.offlineOrderStatus,
    refetchOnWindowFocus: true,
    staleTime: 5 * 1000,
  });

  const isOffline = computed(() => result.value?.data.isOffline);

  return {
    isLoadingOfflineStatus,
    isErrorOfflineStatus,
    isSuccessOfflineStatus,
    isOffline,
  };
}
